import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Learn Gatsby and NextJS with my new workshop",
  "description": "Think of the last time you started a new project. You spend the first few hours getting started. Ugh",
  "published": "2020-10-28T00:00:00.000Z",
  "hero": "./img/screenshot-1603902593346.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`We're talking about the JAMStack this week and how it helps you ship. 🛳`}</p>
    <p>{`And maybe that sounds weird. It's a buzzword Netlify invented to describe modern webapps. Here's what we're `}<em parentName="p">{`really`}</em>{` talking about 👉 Gatsby and NextJS.`}</p>
    <p>{`Think of the last time you started a new project. At work, that happens rarely. You've got the config sorted. Yeah it's annoying to change and you sometimes clash with your coworkers.`}</p>
    <p>{`But you can deal.`}</p>
    <p>{`On your own, though, that's when things get frustrating. You spend the first few hours getting started.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`You ever spend so long getting the project setup that by the time you're done, you're all "Fuck it. I don't want to do the damn thing any more."?`}</p>{`— Kyle Shevlin (@kyleshevlin) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/kyleshevlin/status/1320774265218633728"
      }}>{`October 26, 2020`}</a></blockquote>
    <p>{`Kyle gets it.`}</p>
    <p>{`I used to, but I don't anymore. Screw that.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`This is why I always:`}<br parentName="p"></br><br parentName="p"></br>{`$ gatsby init`}<br parentName="p"></br>{`or`}<br parentName="p"></br>{`$ npx create-next-app`}<br parentName="p"></br><br parentName="p"></br>{`and then`}<br parentName="p"></br><br parentName="p"></br>{`$ now deploy`}<br parentName="p"></br><br parentName="p"></br>{`Screw the setup. Ain't nobody got time for that.`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1320776658681393152"
      }}>{`October 26, 2020`}</a></blockquote>
    <p>{`You see I used to be a Linux nerd back in the 2000's. One time I spent 3 days recompiling my entire operating system to flip a configuration flag that enabled dual monitors.`}</p>
    <p>{`Compiling an operating system on a single core 1000GHz AMD Athlon ... ah the folly of youth.`}</p>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media1.giphy.com/media/ZazvVSkRzwyponrIA2/giphy-loop.mp4?cid=7cf28b0fhooh2coodpg2ayhbzm6qqay2jf0ls0jsx9pguxe1&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <p>{`When I switched to Mac, fussing with my computer melted away into the distance. Tweak 1 or 2 configs and you're done. Computer works.`}</p>
    <p>{`You've outsourced all the annoying stuff and you're free to work on `}<em parentName="p">{`your`}</em>{` projects. No fiddling with tools.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Another way to look at it: Our profession used to think compilers will put us out of business. Why hire a expert programmer if software can do 80% of the work?`}<br parentName="p"></br><br parentName="p"></br>{`Because the programmer is now free to do more important things.`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1320917416415617025"
      }}>{`October 27, 2020`}</a></blockquote>
    <h2 {...{
      "id": "the-jamstack-workshop"
    }}>{`The JAMStack workshop`}</h2>
    <p>{`That's what the JAMStack workshop is about my friend. Showing you the tools that let you focus on `}<em parentName="p">{`your`}</em>{` project. Screw the basics everyone needs.`}</p>
    <p>{`Join now and on `}<strong parentName="p">{`November 9th at 11am Pacific`}</strong>{` you'll learn how to build a modern webapp. The user-facing parts.`}</p>
    <p><a parentName="p" {...{
        "href": "https://gum.co/PdwnF"
      }}><span parentName="a" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "101.34529147982063%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'406\\'%20viewBox=\\'0%200%20400%20406\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M10%208L9%20115v107h41l-1-14a6398%206398%200%2001-1-27c-2-5%200-11%2010-29%209-17%2016-27%2019-27%202%200%201%207-2%2014l-12%2030c0%202%205-1%206-3%202-2%207-7%2013-10l3-3%204-4%204-3v4c0%207-1%2013-3%2014-7%203-16%2015-26%2035-3%206-1%2012%203%2011%202%200%203%201%204%203%201%203%205%203%205-1%200-2%200-2%202-1l7-3c4-3%206-3%206%201l2%204c3%202-1%208-5%208h-9l153%201h159V8L200%207%2010%208m372%2028l-3%2028-1%2023v20l1%2012h3c3%200%204-1%206-6s2-7%202-28c0-25-1-49-3-51-1-3-4-2-5%202m-186%201l-8%201c-7%200-12%202-5%202%204%200%208%202%206%203-4%202-15%200-13-3%203-3-3-4-11%200l-6%202-4%201-3%201c-4-2-6%202-5%208l1%206%203%204%202%202%202%201c1%201%201%201%203-1%201-2%204-3%205-3l4-1c6-4%2017-5%2017-1%200%201%202%201%202-1h2l2%203c0%201%205%202%209%201l2%201c-1%202%205%201%206%200l1-2%201-3%201-1%203-4c2-7%201-8-4-7s-6%201-4-2c1-1%200-2-1-4-3-3-8-5-8-3m153%2034l-5%201c-6%200-7%201-5%203l-1%203c-2%203-2%204-2%2034a776%20776%200%20002%2041c0%202%203%203%206%202l1%203c0%202%201%202%201-2v-6c-2-2-1-4%201-4l1-1c-2-2%202-1%206%202%206%204%209%204%209%200l2-4%201-3%201-1v-5c0-3%200-6%202-10%202-5%202-6%202-19l-2-15-1-3c-1-5-2-7-4-6-2%200-2%200-2-2%202-4-1-6-10-7l-1-1-1-1-1%201m-149%209l-3%207-2%207v4l1%202c-1%201%201%201%206%201%207%200%208%200%207-2l-3-17c1-1%201-2-1-3s-2-1-5%201m-18%209c-7%203-8%203-19%200-9-2-11%202-3%2010s24%205%2031-5c4-7%201-8-9-5m51-1l-1%202c1%202-2%203-5%201-1-1-2-1-2%201-1%201-1%201-1-1%200-4-3-4-4%200l-1%202c-1%201%203%204%207%204h1l-1-1%201-1c1%201%202%200%203-1h7l2-2c3-3-3-6-6-4m-82%206c0%203%200%205%202%205l1%203%202%203c1%200%202%201%201%203l1%203c1%200%202%201%201%202l1%201%201%203%201%202%201%203%201%203%203%202%202%204%201%205%201%203%201%203c1%204%203%207%204%205v-2l-1-3-1-3c-2%200%200-4%204-8s5-5%204-7l-1-8-1-5h-1l-4-1c-3%200-3-2%200-3%202-1%201-1-3-1-9%200-15-4-19-12l-2-4v4m-11%209v8c0%202%200%202-2-1l-4-5-1%2013%201%2016v7l-1%201%202%201%201%201v2l1%207%202%207c1%201%202%202%201%203l1%201c2-1%202%200%202%202%200%206%206%204%2012-3%204-5%204-5%203-11l-4-17c-2-5-3-6-6-8l-5-3h1l4%201c2%200%202%200%201-4l-3-5c-4-2-5-8-3-12s2-4%200-5-2%200-3%204m166%2031v12h11v-5c1-4%200-5-1-7-3-1-10-2-10%200m-121%2030c0%201%205%205%209%205%2016%203%2020%202%2020-2h-16l-5-1-5-2c-1-1-3-2-3%200m-77%2037l-7%209c-4%204-4%206%201%203l6-3c5-2%207-4%205-7l-1-4c0-4-1-4-4%202m215%202c-2%208%201%2011%2012%209%205%200%206-1%206-6%200-6%200-6-10-6h-8v3M43%20266v5l1%203c-1%202%203%203%206%202l2-3%201-3v-3l-1-2-3-1c-3%200-4%200-6%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/67bd3d0e8102c57641c4862a7faa875c/ca0a1/00W2p7pngdh5fjh.webp 223w", "/static/67bd3d0e8102c57641c4862a7faa875c/75680/00W2p7pngdh5fjh.webp 445w", "/static/67bd3d0e8102c57641c4862a7faa875c/8d1ba/00W2p7pngdh5fjh.webp 890w", "/static/67bd3d0e8102c57641c4862a7faa875c/3838e/00W2p7pngdh5fjh.webp 1335w", "/static/67bd3d0e8102c57641c4862a7faa875c/6a202/00W2p7pngdh5fjh.webp 1444w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/67bd3d0e8102c57641c4862a7faa875c/e92b6/00W2p7pngdh5fjh.png 223w", "/static/67bd3d0e8102c57641c4862a7faa875c/e66bf/00W2p7pngdh5fjh.png 445w", "/static/67bd3d0e8102c57641c4862a7faa875c/4ef49/00W2p7pngdh5fjh.png 890w", "/static/67bd3d0e8102c57641c4862a7faa875c/4e814/00W2p7pngdh5fjh.png 1335w", "/static/67bd3d0e8102c57641c4862a7faa875c/5faa8/00W2p7pngdh5fjh.png 1444w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/67bd3d0e8102c57641c4862a7faa875c/4ef49/00W2p7pngdh5fjh.png",
              "alt": "00W2p7pngdh5fjh",
              "title": "00W2p7pngdh5fjh",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></a></p>
    <p>{`The JAMStack Workshop is a 4 hour interactive workshop focused on practical exercises. You'll spend the whole time coding and answering questions. No boring lectures allowed.`}</p>
    <p>{`Here's what a student had to say about a past workshop:`}</p>
    <blockquote>
      <p parentName="blockquote">{`Very hands on - excellent documentation and everything worked!!`}</p>
    </blockquote>
    <p>{`I've spent the last 3 years perfecting my approach to workshops. You're gonna love this my friend.`}</p>
    <p>{`No worries if you can't join live, the full recording is yours forever. But it's more fun live. You get to ask questions. 😉`}</p>
    <p>{`And the mini-course you get in advance means we can spend our whole 4 hours together focusing on the exercises.`}</p>
    <p>{`Or to quote another student from a past workshop:`}</p>
    <blockquote>
      <p parentName="blockquote">{`Wow Swizec this was fantastic! It would take us `}<em parentName="p">{`months`}</em>{` to figure this out on our own and you showed us in 4 hours.`}</p>
    </blockquote>
    <h2 {...{
      "id": "what-we-cover"
    }}>{`What we cover`}</h2>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://gum.co/PdwnF"
      }}>{`JAMStack Workshop`}</a>{` teaches you Gatsby AND NextJS. Yes both.`}</p>
    <p>{`Why both? Because they're great for different reasons.`}</p>
    <p>{`Gatsby works better for website-y apps and NextJS is better at webapps. Both can do either, but feel clunky when used for the wrong purpose.`}</p>
    <p>{`Both are fantastic to use. Gatsby has more plugins and a larger community, NextJS has the backing of its own JAMStack provider (Vercel).`}</p>
    <p>{`Both Gatsby and NextJS are based on the same principles:`}</p>
    <ul>
      <li parentName="ul">{`React on the frontend`}</li>
      <li parentName="ul">{`static-first UI generation`}</li>
      <li parentName="ul">{`JAMStack deployment`}</li>
      <li parentName="ul">{`build tools configured`}</li>
      <li parentName="ul">{`routing configured`}</li>
      <li parentName="ul">{`fantastic defaults to work with`}</li>
    </ul>
    <p><em parentName="p">{`That`}</em>{`'s the key takeaway for this workshop. You'll learn the mindset behind a modern webapp. Whether you build with Gatsby, NextJS, your own setup, or the meta framework that comes out next week.`}</p>
    <p>{`Once you understand the mindset my friend, a new framework is just an implementation detail. You might even build your own.`}</p>
    <h2 {...{
      "id": "more-of-whats-inside"
    }}>{`More of what's inside`}</h2>
    <p>{`Gatsby and NextJS are great and I know you're smart enough to figure them out on your own. Jump into the docs for a few weeks and voila.`}</p>
    <p>{`The JAMStack Workshop focuses on cutting through the noise with an opinionated guide based on years of experience.`}</p>
    <p>{`You'll learn:`}</p>
    <ul>
      <li parentName="ul">{`how Gatsby and NextJS work`}</li>
      <li parentName="ul">{`how to use a flexible design system`}</li>
      <li parentName="ul">{`use other people's themes to skip fussy design steps`}</li>
      <li parentName="ul">{`add dark mode 🤘`}</li>
      <li parentName="ul">{`file-based routing and why that's a good idea`}</li>
      <li parentName="ul">{`using Markdown for content`}</li>
      <li parentName="ul">{`with MDX for rich JS-enabled content`}</li>
      <li parentName="ul">{`dynamic data loading in the browser`}</li>
      <li parentName="ul">{`static builds for your app with baked-in data`}</li>
      <li parentName="ul">{`keeping static data fresh when users navigate`}</li>
    </ul>
    <p>{`You get blazing fast static-first apps with constantly fresh data, without shitloads of hard work to get there.`}</p>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media1.giphy.com/media/fsQbx1hX7hPBBpIM5b/giphy-loop.mp4?cid=7cf28b0fjspjdfkn3kfeizndf2zddstx1vdwpdzt1pxntrgw&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <h2 {...{
      "id": "how-it-works"
    }}>{`How it works`}</h2>
    <p>{`Here's the best part: The JAMStack Workshop comes with a mini course.`}</p>
    <p>{`You start with 20 to 30 minutes of video. A couple lessons where I explain the theory.`}</p>
    <p>{`At the workshop, you're doing exercises. Everything's an exercise. I pose a problem, add light instructions, you create the solution. Then we walk through my solution and compare.`}</p>
    <p>{`Solving problems is the best way to learn. Reading solutions doesn't work. Research says so.`}</p>
    <p>{`And the mini-course you get in advance means we can spend our whole 4 hours together focusing on the exercises.`}</p>
    <p>{`Or to quote another student from a past workshop:`}</p>
    <blockquote>
      <p parentName="blockquote">{`Wow Swizec this was fantastic! It would take us `}<em parentName="p">{`months`}</em>{` to figure this out on our own and you showed us in 4 hours.`}</p>
    </blockquote>
    <p>{`Join `}<a parentName="p" {...{
        "href": "https://gum.co/PdwnF"
      }}>{`The JAMStack Workshop`}</a>{` today. Enrollment closes Friday ✌️`}</p>
    <p>{`Got questions? hit reply`}</p>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>
    <p>{`PS: you can `}<a parentName="p" {...{
        "href": "https://gum.co/rhBat"
      }}>{`buy in 3 installments of `}{`\\`}{`\\$99`}</a>{`, if that's easier :)`}</p>
    <p>{`and there's a team discount`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      